<template>
    <div class="row" >
        <div class="col-12 col-xs-6 form-group">
            <p :class="sectionTitleClass">
                <slot/>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        sectionTitleClass: {
            type: String,
            required: false,
            default: '',
        }
    }
}
</script>
<style scoped>
    .section-title-contianer__title-container {
        margin:0px;
        color: #3aa1ca;
    }
</style>


// WEBPACK FOOTER //
// src/views/followair/atualizacao-manual/components/sectionTitle/sectionTitleContainer.vue